<template>
    <div class="form card-bind view">
        <slot name="header"></slot>

        <alert v-if="error" type="fail" class="form__alert">
            {{ $t(error) }}
        </alert>

        <div class="card-bind__current-cards" v-if="paymentMethodsState.value.length">
            <div class="row card-bind__current-card" v-for="method in paymentMethodsState.value">
                <div class="span-5 card-bind__current-card-text">
                    <div class="text">
                        Вы можете использовать банковскую карту
                        <br>
                        {{ method.number }}
                    </div>
                </div>
                <div class="span-3 card-bind__current-card-buttons">
                    <tippy content="Недоступно для тестового полиса" arrow v-if="policy.test">
                        <template v-slot:trigger>
                            <button class="button button--md button--secondary" disabled>
                                Использовать
                            </button>
                        </template>
                    </tippy>
                    <button v-else class="button button--md button--secondary" @click.prevent="use(method)"
                        :disabled="policy.test || bindExistingPaymentMethodState.inProcess"
                    >
                        Использовать
                    </button>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="span-7">
                <div id="yandex-kassa-form"></div>
            </div>
        </div>
    </div>
</template>

<script>
  import {
    CREATE_PAYMENT,
    FETCH_PAYMENT_METHODS,
    BIND_EXISTING_PAYMENT_METHOD
  } from '../../store/actions.type';
  import { mapActions, mapGetters } from 'vuex';

  export default {
    computed: {
      ...mapGetters('policy', ['policy']),
      ...mapGetters('cardBind', [
        'paymentMethodsState',
        'createTransactionAndInitWidgetState',
        'bindExistingPaymentMethodState'
      ]),
      error() {
        return this.paymentMethodsState.error ||
          this.bindExistingPaymentMethodState.error ||
          this.createTransactionAndInitWidgetState.error

      }
    },
    async created() {
      this[FETCH_PAYMENT_METHODS]();
    },
    async mounted () {
      let render = await this[CREATE_PAYMENT]();
      if (typeof render === 'function') {
        render("yandex-kassa-form");
      }
    },
    methods: {
      async use(paymentMethod) {
        await this[BIND_EXISTING_PAYMENT_METHOD](paymentMethod);
        if (!this.error) {
          this.$emit('completed');
        }
      },
      ...mapActions('cardBind', [
        CREATE_PAYMENT,
        FETCH_PAYMENT_METHODS,
        BIND_EXISTING_PAYMENT_METHOD
      ])
    }
  }
</script>

<style lang="scss">
    .card-bind__form {
        background: #eee;
        border-radius: 10px;
        &:before {
            content: '';
            display: block;
            padding-bottom: 57%;
        }
    }
    .card-bind__current-cards {
        margin-bottom: 50px;
    }
    .card-bind__current-card {
        margin-bottom: 20px;
        @include mq(mobile) {
            margin-bottom: 30px;
        }
    }
    .card-bind__current-card-text {
        @include mq(mobile) {
            margin-bottom: 10px;
        }
    }
    .card-bind__conditions-note {
        margin-top: 40px;
    }
</style>